/** P32 (Feb 27, 2026) — Review-mode top bar with progress + keyboard hints. */
import React from 'react';
import { X } from '@phosphor-icons/react';
import { Button } from '../../ui/button';

const TopBar = ({ index, total, onClose }) => (
  <div className="h-14 bg-slate-950 border-b border-slate-800 flex items-center justify-between px-4 shrink-0">
    <div className="flex items-center gap-3">
      <Button
        size="sm"
        variant="ghost"
        onClick={onClose}
        className="text-slate-300 hover:text-white hover:bg-slate-800"
        data-testid="review-exit"
      >
        <X size={18} className="mr-1" /> Exit
      </Button>
      <div className="text-sm text-slate-300">
        Reviewing <span className="font-semibold text-white">{index + 1}</span> of {total}
      </div>
      <div className="w-48 h-1.5 bg-slate-800 rounded-full overflow-hidden">
        <div
          className="h-full bg-indigo-500 transition-all"
          style={{ width: `${((index + 1) / total) * 100}%` }}
        />
      </div>
    </div>
    <div className="flex items-center gap-2 text-xs text-slate-400">
      <kbd className="px-1.5 py-0.5 bg-slate-800 rounded border border-slate-700">←</kbd>
      <kbd className="px-1.5 py-0.5 bg-slate-800 rounded border border-slate-700">→</kbd>
      <span>navigate</span>
      <span className="mx-2">·</span>
      <kbd className="px-1.5 py-0.5 bg-slate-800 rounded border border-slate-700">Enter</kbd>
      <span>confirm</span>
      <span className="mx-2">·</span>
      <kbd className="px-1.5 py-0.5 bg-slate-800 rounded border border-slate-700">Del</kbd>
      <span>skip</span>
      <span className="mx-2">·</span>
      <kbd className="px-1.5 py-0.5 bg-slate-800 rounded border border-slate-700">Esc</kbd>
      <span>exit</span>
    </div>
  </div>
);

export default TopBar;
